var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('ValidationObserver', {
    ref: "pmFormModal",
    staticClass: "d-contents",
    attrs: {
      "immediate": ""
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(_ref) {
        var _vm$user$phoneMobile;
        var validationFailed = _ref.failed;
        return [_c('b-modal', {
          attrs: {
            "id": "modalPmForm",
            "title": _vm.getTitle,
            "modal-class": _vm.customClass ? "".concat(_vm.customClass, " form-modal") : "form-modal",
            "cancel-title": "Cancel",
            "ok-title": "Submit",
            "centered": true,
            "ok-disabled": !_vm.user.id || validationFailed || _vm.submitting || !_vm.hasUserChanged
          },
          on: {
            "show": _vm.loadUserVariable,
            "hidden": _vm.clearUserVariable,
            "cancel": _vm.handlePmFormCancel,
            "ok": _vm.handlePmFormOK
          }
        }, [!_vm.user.id ? _c('LoaderIcon', {
          staticClass: "m-auto",
          attrs: {
            "error": _vm.error
          }
        }) : _vm._e(), _vm.user.id ? _c('div', [_vm.form === 'roles' ? _c('div', [_c('div', [_c('FormItemGroup', [!_vm.user.isAccessOnly ? _c('PersonnelFormItemCheckbox', {
          attrs: {
            "label": "Office Employee",
            "value": _vm.user.groupPersonnelLabels,
            "edit-mode": true,
            "immediate-validation": "",
            "rules": _vm.user.isBrokerOwner ? '' : 'required',
            "checkbox-sub-labels": _vm.roleOptionsSubLabels,
            "multi-select": "",
            "edit-checkbox-values": _vm.roleOptions,
            "exclusive-values": [['LOA - Licensed', 'LOA - Unlicensed'], ['Loan Originator Phase 1', 'Loan Originator Phase 2']],
            "disabled-checkbox-values": _vm.getUserReadOnlyRoles({
              user: _vm.user
            }),
            "placeholder": "Select..."
          },
          on: {
            "update:value": function updateValue($event) {
              return _vm.$set(_vm.user, "groupPersonnelLabels", $event);
            }
          },
          scopedSlots: _vm._u([{
            key: "label",
            fn: function fn() {
              return [_c('p', {
                staticClass: "button-text bold mb-3"
              }, [_vm._v("Choose all that apply: ")])];
            },
            proxy: true
          }], null, true)
        }) : _vm._e()], 1)], 1)]) : _vm._e(), _vm.form === 'overview' ? _c('div', [_c('div', [_c('FormItemGroup', [_c('FormItem', {
          attrs: {
            "label": "Job Title",
            "character-limit-options": {
              showOnlyError: true
            },
            "rules": "max:60",
            "edit-mode": "",
            "value": _vm.user.jobTitle
          },
          on: {
            "update:value": function updateValue($event) {
              return _vm.$set(_vm.user, "jobTitle", $event);
            }
          }
        }), _c('div')], 1), _c('FormItemGroup', [_c('FormItemPhone', {
          attrs: {
            "phone-label": "Work Line",
            "edit-mode": "",
            "disabled": _vm.submitting,
            "phone": _vm.user.phone,
            "phone-ext": _vm.user.phoneExt,
            "rules": "required|validPhoneNumber"
          },
          on: {
            "update:phone": function updatePhone($event) {
              return _vm.$set(_vm.user, "phone", $event);
            },
            "update:phoneExt": function updatePhoneExt($event) {
              return _vm.$set(_vm.user, "phoneExt", $event);
            },
            "update:phone-ext": function updatePhoneExt($event) {
              return _vm.$set(_vm.user, "phoneExt", $event);
            }
          }
        }), _c('div', [_c('FormItemPhone', {
          attrs: {
            "phone-label": "Mobile Number",
            "edit-mode": "",
            "disabled": _vm.submitting,
            "phone": _vm.user.phoneMobile,
            "phone-ext": _vm.user.phoneMobileExt,
            "phone-ext-label": "Ext. Mobile",
            "rules": _vm.hadMobilePhoneInitially ? 'required|validPhoneNumber' : 'validPhoneNumber'
          },
          on: {
            "update:phone": function updatePhone($event) {
              return _vm.$set(_vm.user, "phoneMobile", $event);
            },
            "update:phoneExt": function updatePhoneExt($event) {
              return _vm.$set(_vm.user, "phoneMobileExt", $event);
            },
            "update:phone-ext": function updatePhoneExt($event) {
              return _vm.$set(_vm.user, "phoneMobileExt", $event);
            },
            "blur": _vm.mobilePhoneUpdated
          }
        }), _c('div', {
          staticClass: "mt-2 ml-2 d-flex align-items-center"
        }, [_c('ValidationProvider', {
          attrs: {
            "name": 'publishToWeb'
          }
        }, [_c('BaseCheckbox', {
          staticClass: "mr-2",
          class: [((_vm$user$phoneMobile = _vm.user.phoneMobile) === null || _vm$user$phoneMobile === void 0 ? void 0 : _vm$user$phoneMobile.length) === 12 ? '' : 'pe-none'],
          attrs: {
            "label": "Publish to Web",
            "input-value": "1"
          },
          model: {
            value: _vm.publishToWeb,
            callback: function callback($$v) {
              _vm.publishToWeb = $$v;
            },
            expression: "publishToWeb"
          }
        })], 1), _c('Tooltip', {
          attrs: {
            "target": 'publish-to-web',
            "icon-absolute-position": false,
            "placement": "top",
            "theme": "blue"
          }
        }, [_vm._v(" Checking this box will publish your Mobile number on the web. ")])], 1)], 1)], 1), _c('FormItemGroup', [_c('FormItem', {
          attrs: {
            "label": "Time Zone",
            "edit-mode": "",
            "disabled": _vm.submitting,
            "rules": 'required',
            "edit-select-values": _vm.getTimeZoneOptions,
            "value": _vm.user.timezoneValue
          },
          on: {
            "update:value": function updateValue($event) {
              return _vm.$set(_vm.user, "timezoneValue", $event);
            }
          }
        }), _c('FormItemBirthDay', {
          attrs: {
            "edit-mode": "",
            "disabled": _vm.submitting,
            "birth-day": _vm.user.birthDay,
            "birth-month": _vm.user.birthMonth
          },
          on: {
            "update:birthDay": function updateBirthDay($event) {
              return _vm.$set(_vm.user, "birthDay", $event);
            },
            "update:birth-day": function updateBirthDay($event) {
              return _vm.$set(_vm.user, "birthDay", $event);
            },
            "update:birthMonth": function updateBirthMonth($event) {
              return _vm.$set(_vm.user, "birthMonth", $event);
            },
            "update:birth-month": function updateBirthMonth($event) {
              return _vm.$set(_vm.user, "birthMonth", $event);
            }
          }
        })], 1), _c('FormItemGroup', [_c('FormItem', {
          attrs: {
            "label": "Motto Email",
            "value": _vm.user.primaryEmail
          }
        }), !_vm.user.secondaryEmailTemp ? _c('FormItem', {
          attrs: {
            "label": "Personal Email",
            "edit-mode": "",
            "disabled": _vm.submitting,
            "character-limit-options": {
              showOnlyError: true
            },
            "value": _vm.user.secondaryEmail,
            "rules": "required|email|max:75"
          },
          on: {
            "update:value": function updateValue($event) {
              return _vm.$set(_vm.user, "secondaryEmail", $event);
            }
          }
        }) : _vm._e(), _vm.user.secondaryEmailTemp ? _c('FormItem', {
          attrs: {
            "label": "Personal Email",
            "value": _vm.user.secondaryEmailTemp,
            "tooltip-text": 'A confirmation has been sent to your personal email. Please verify your email address.'
          }
        }) : _vm._e()], 1)], 1)]) : _vm._e()]) : _vm._e(), _vm.form === 'marketing' ? _c('div', [_c('div', [_c('FormItemGroup', [_c('FormItem', {
          attrs: {
            "label": "Facebook",
            "placeholder": "facebook.com",
            "edit-mode": "",
            "disabled": _vm.submitting,
            "value": _vm.user.facebook
          },
          on: {
            "update:value": function updateValue($event) {
              return _vm.$set(_vm.user, "facebook", $event);
            }
          }
        }), _c('FormItem', {
          attrs: {
            "label": "Twitter",
            "placeholder": "twitter.com",
            "edit-mode": "",
            "disabled": _vm.submitting,
            "value": _vm.user.twitter
          },
          on: {
            "update:value": function updateValue($event) {
              return _vm.$set(_vm.user, "twitter", $event);
            }
          }
        }), _c('FormItem', {
          attrs: {
            "label": "LinkedIn",
            "placeholder": "linkedin.com",
            "edit-mode": "",
            "disabled": _vm.submitting,
            "value": _vm.user.linkedin
          },
          on: {
            "update:value": function updateValue($event) {
              return _vm.$set(_vm.user, "linkedin", $event);
            }
          }
        })], 1), _c('FormItemGroup', [_c('FormItem', {
          attrs: {
            "label": "Instagram",
            "placeholder": "instagram.com",
            "edit-mode": "",
            "disabled": _vm.submitting,
            "value": _vm.user.instagram
          },
          on: {
            "update:value": function updateValue($event) {
              return _vm.$set(_vm.user, "instagram", $event);
            }
          }
        }), _c('FormItem', {
          attrs: {
            "label": "Snapchat",
            "placeholder": "snapchat.com",
            "edit-mode": "",
            "disabled": _vm.submitting,
            "value": _vm.user.snapchat
          },
          on: {
            "update:value": function updateValue($event) {
              return _vm.$set(_vm.user, "snapchat", $event);
            }
          }
        }), _c('div')], 1), _c('FormItemGroup', [_c('FormItem', {
          attrs: {
            "label": "Website",
            "copyable": "",
            "placeholder": "Website",
            "value": _vm.user.domain
          }
        }), _c('FormItem', {
          attrs: {
            "label": "Application URL",
            "copyable": "",
            "placeholder": "Application URL",
            "value": _vm.user.mortgageApplicLink
          },
          on: {
            "update:value": function updateValue($event) {
              return _vm.$set(_vm.user, "mortgageApplicLink", $event);
            }
          }
        }), _c('FormItem', {
          attrs: {
            "label": "Google My Business",
            "placeholder": "google.com",
            "value": _vm.user.google
          }
        })], 1), _c('FormItemGroup', [_c('FormItemAddMultiple', {
          attrs: {
            "input-container-class": _vm.$style.keywordsInput,
            "value": _vm.user.keywords,
            "edit-mode": "",
            "disabled": _vm.submitting,
            "label": "SEO Keywords",
            "is-changed": _vm.getChangedFields('pmFormModal').includes('SEO Keywords'),
            "placeholder": "Add Keyword"
          },
          on: {
            "update:value": function updateValue($event) {
              return _vm.$set(_vm.user, "keywords", $event);
            }
          }
        })], 1), _c('FormItemGroup', [_c('FormItem', {
          attrs: {
            "label": "ORM Location Description",
            "placeholder": _vm.getLocationDetailsPlaceholder,
            "tooltip-text": "The following will be used to fill in any website listing descriptions on websites such as Google, Bing, Yelp, and many more. If you would like something else please enter your own description below.  Limit is 750 characters.",
            "edit-mode": "",
            "textarea": "",
            "disabled": _vm.submitting,
            "value": _vm.user.locationDetails,
            "rules": "max:750"
          },
          on: {
            "update:value": function updateValue($event) {
              return _vm.$set(_vm.user, "locationDetails", $event);
            }
          }
        })], 1), _c('FormItemGroup', [_c('FormItem', {
          attrs: {
            "label": "Short Web Description",
            "placeholder": "Short Web Description",
            "tooltip-text": "Add a short description of your business that will appear across the web where a short business description is available with your populated information.  Limit is 100 characters.",
            "edit-mode": "",
            "disabled": _vm.submitting,
            "value": _vm.user.shortDescription,
            "rules": "max:100"
          },
          on: {
            "update:value": function updateValue($event) {
              return _vm.$set(_vm.user, "shortDescription", $event);
            }
          }
        })], 1)], 1)]) : _vm._e(), _vm.form === 'notifications' ? _c('div', [_c('div', [_c('div', [_vm.hasSmsPromptsFeature ? _c('div', {
          staticClass: "mb-4"
        }, [_c('h2', [_vm._v("SMS")]), _c('div', {
          staticClass: "ml-3 mt-3"
        }, [_c('h4', {
          staticClass: "font-weight-bold"
        }, [_vm._v("MottoMortgage Network Alerts")]), _c('p', {
          staticClass: "p1"
        }, [_vm._v(" Opt in to receive important messages regarding marketing, events, and general information about tools, services, and support of the Motto Mortgage network. Message frequency varies. Text HELP to 58476 or call 866-668-8660 for help, STOP to 58476 to end. Message and Data rates may apply. By opting in, you authorize Motto Mortgage to deliver marketing messages using an automatic telephone dialing system. You are not required to opt in as a condition of purchasing any property, goods, or services. By checking the box below, you agree to the "), _c('RouterLink', {
          staticClass: "button-text text-decoration-none color-primary-blue",
          attrs: {
            "to": {
              name: 'mobileTerms'
            },
            "target": "_blank"
          }
        }, [_vm._v("MOBILE TERMS OF USE")]), _vm._v(" and "), _c('a', {
          staticClass: "button-text text-decoration-none color-primary-blue",
          attrs: {
            "href": "https://www.mottomortgage.com/privacy-policy",
            "target": "_blank"
          }
        }, [_vm._v("Motto Mortgage Privacy Policy")]), _vm._v(" and "), _c('RouterLink', {
          staticClass: "button-text text-decoration-none color-primary-blue",
          attrs: {
            "to": {
              name: 'userAgreement'
            },
            "target": "_blank"
          }
        }, [_vm._v("USER AGREEMENT")]), _vm._v(". ")], 1), _c('div', {
          staticClass: "d-flex mt-3 align-items-center",
          class: _vm.$style.optInMobileNumberContainer
        }, [_c('ValidationProvider', {
          attrs: {
            "name": 'optInMobile'
          }
        }, [_c('FormItemPhone', {
          staticClass: "mt-2 mb-4",
          class: _vm.$style.notificationPhoneSms,
          attrs: {
            "phone-label": "Mobile Number",
            "disabled": !_vm.hasOptedInSMS[0],
            "edit-mode": "",
            "hide-ext": "",
            "options": {
              hideAsterisk: true
            },
            "phone-placeholder": "Mobile Number",
            "phone": _vm.user.phoneMobile,
            "rules": _vm.hasOptedInSMS[0] ? 'required|validPhoneNumber' : ''
          },
          on: {
            "update:phone": function updatePhone($event) {
              return _vm.$set(_vm.user, "phoneMobile", $event);
            }
          }
        }), _c('BaseCheckbox', {
          attrs: {
            "label": "I’d like to receive text messages from Motto HQ.",
            "input-value": "1"
          },
          model: {
            value: _vm.hasOptedInSMS,
            callback: function callback($$v) {
              _vm.hasOptedInSMS = $$v;
            },
            expression: "hasOptedInSMS"
          }
        })], 1)], 1)])]) : _vm._e(), _c('div', {
          staticClass: "mb-3"
        }, [_c('h2', [_vm._v("Email")]), _c('div', {
          staticClass: "ml-3 mt-3"
        }, [_c('h4', {
          staticClass: "font-weight-bold"
        }, [_vm._v("Network Connect")]), _c('p', {
          staticClass: "p1"
        }, [_vm._v("Opt-in to receive email notifications for Network Connect deal-level referrals.")]), _c('div', {
          staticClass: "d-flex mt-3 align-items-center",
          class: _vm.$style.optInMobileNumberContainer
        }, [_c('ValidationProvider', {
          attrs: {
            "name": 'optInEmail'
          }
        }, [_c('BaseCheckbox', {
          attrs: {
            "label": "Deal-level referral email notifications",
            "input-value": "1"
          },
          model: {
            value: _vm.emailNotificationReferral,
            callback: function callback($$v) {
              _vm.emailNotificationReferral = $$v;
            },
            expression: "emailNotificationReferral"
          }
        })], 1)], 1)])])])])]) : _vm._e(), _vm.form === 'request_licenses' ? _c('div', [_c('div', [_c('div', [_c('FormItemGroup', [_c('PersonnelFormLicenseStates', {
          attrs: {
            "label": "State(s) of Licensure",
            "edit-mode": "",
            "rules": 'required',
            "edit-select-values": _vm.availableStates,
            "read-only-values": _vm.user.originalLicenses,
            "disabled": !(_vm.primaryOfficeLicenses && _vm.primaryOfficeLicenses.length) || _vm.submitting,
            "placeholder": _vm.primaryOfficeLicenses && _vm.primaryOfficeLicenses.length ? 'Select...' : 'No states are eligible for this user',
            "value": _vm.user.licenses
          },
          on: {
            "update:value": function updateValue($event) {
              return _vm.$set(_vm.user, "licenses", $event);
            }
          }
        })], 1)], 1)])]) : _vm._e()], 1)];
      }
    }])
  }), _c('ModalOptInMobilePrompt', {
    attrs: {
      "mobile-number": _vm.user.phoneMobile
    },
    on: {
      "update:mobileNumber": function updateMobileNumber($event) {
        return _vm.$set(_vm.user, "phoneMobile", $event);
      },
      "update:mobile-number": function updateMobileNumber($event) {
        return _vm.$set(_vm.user, "phoneMobile", $event);
      },
      "ok-opt-in": _vm.okOptInMobilePromptModal,
      "cancel-opt-in": _vm.cancelOptInMobilePromptModal
    }
  })], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }